import axios from "axios";

// Debe coincidir con SERVICIO_NO_ACTIVO de server/src/helpers/servicioActivo.helper.js
export const SERVICIO_NO_ACTIVO = "SERVICIO_NO_ACTIVO";

const API = process.env.REACT_APP_API_URL;

const readJSON = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "null");
  } catch {
    return null;
  }
};

export const leerServicioActivoLocal = () => readJSON("servicioActivo");

/** Borra todo rastro local del servicio activo (cache + user). */
export const limpiarServicioActivoLocal = () => {
  localStorage.removeItem("servicioActivo");
  const user = readJSON("user");
  if (user && (user.servicioActivo || user.servicioInicio)) {
    user.servicioActivo = null;
    user.servicioInicio = null;
    localStorage.setItem("user", JSON.stringify(user));
  }
};

/** Guarda el servicio activo confirmado por el servidor. */
export const guardarServicioActivoLocal = ({ cronogramaId, servicioInicio, acumuladoSegundos }) => {
  const local = leerServicioActivoLocal();
  const inicio = servicioInicio ? new Date(servicioInicio).getTime() : Date.now();
  localStorage.setItem(
    "servicioActivo",
    JSON.stringify({
      cronogramaId,
      inicio,
      acumuladoSegundos:
        acumuladoSegundos ??
        (local?.cronogramaId === cronogramaId ? local.acumuladoSegundos || 0 : 0),
    }),
  );
  const user = readJSON("user");
  if (user) {
    user.servicioActivo = cronogramaId;
    user.servicioInicio = servicioInicio || new Date(inicio).toISOString();
    localStorage.setItem("user", JSON.stringify(user));
  }
};

export const esErrorServicioNoActivo = (err) =>
  err?.response?.data?.code === SERVICIO_NO_ACTIVO;

/**
 * Consulta al servidor el estado real del servicio activo y sincroniza el
 * cache local. El servidor libera automáticamente registros inconsistentes.
 * @returns {Promise<{activo:boolean, servicioActivo?:string, motivo?:string}>}
 */
export const verificarServicioActivoRemoto = async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    limpiarServicioActivoLocal();
    return { activo: false };
  }
  const { data } = await axios.get(`${API}/cronograma/servicio-activo`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (data.activo) {
    const local = leerServicioActivoLocal();
    if (local?.cronogramaId !== data.servicioActivo) {
      guardarServicioActivoLocal({
        cronogramaId: data.servicioActivo,
        servicioInicio: data.servicioInicio,
      });
    }
  } else {
    limpiarServicioActivoLocal();
  }
  return data;
};
